import { Badge } from "@repo/ui/components/badge";
import { Button } from "@repo/ui/components/button";
import { Card, CardFooter, CardHeader } from "@repo/ui/components/card";
import { useNavigate } from "@tanstack/react-router";
import { ArrowLeft, LayoutDashboardIcon } from "lucide-react";

export function NotFoundPage() {
  const navigate = useNavigate();

  const handleRecover = () => {
    if (globalThis.history.length > 1) {
      globalThis.history.back();
      return;
    }
    void navigate({ to: "/" });
  };

  return (
    <main className="relative flex min-h-svh items-center justify-center overflow-hidden bg-background px-4 py-8 sm:px-6 sm:py-12">
      <Card className="relative mx-auto w-full max-w-2xl overflow-hidden border pt-0 shadow-xl">
        <div className="grid md:grid-cols-[minmax(12rem,15rem)_1fr]">
          <aside className="border-b bg-muted/45 px-6 py-8 md:border-r md:border-b-0 md:px-8 md:py-10">
            <p className="text-xs tracking-[0.2em] text-muted-foreground uppercase">Error Code</p>
            <p className="mt-2 text-7xl leading-none font-semibold tracking-tight md:text-8xl">
              404
            </p>
            <p className="mt-4 text-sm leading-relaxed text-muted-foreground">
              This route is unavailable or was moved.
            </p>
          </aside>

          <div className="flex flex-col pt-8">
            <CardHeader className="gap-3 border-b">
              <Badge variant="outline" className="w-fit">
                Not Found
              </Badge>
              <h1 className="max-w-[24ch] text-3xl leading-tight font-semibold text-balance">
                We could not load this page.
              </h1>
              <p className="max-w-[60ch] text-sm leading-relaxed text-muted-foreground">
                Use the recovery action below. If a previous page exists, you will return there;
                otherwise, you will be sent to your dashboard.
              </p>
            </CardHeader>

            <CardFooter className="flex justify-center gap-2 bg-card">
              <Button
                size="lg"
                className="cursor-pointer touch-manipulation"
                onClick={handleRecover}
              >
                <ArrowLeft aria-hidden="true" className="size-4" />
                Back to Previous Page
              </Button>
              <Button
                size="lg"
                className="cursor-pointer touch-manipulation"
                variant="outline"
                onClick={() => void navigate({ to: "/" })}
              >
                <LayoutDashboardIcon aria-hidden="true" className="size-4" />
                Back to Homepage
              </Button>
            </CardFooter>
          </div>
        </div>
      </Card>
    </main>
  );
}
